import api from '@/api/'

export const form = {
  line_id: undefined, // 发布平台
  platform_class: undefined, // 平台分类
  slug: '', // 标识
  class: undefined, // 类型
  link_url: '', // 跳转链接
  alt: '', // alt属性
  sort: '', // 排序
  start_at: null, // 开始时间
  end_at: null, // 结束时间
  state: 1, // 是否启用
  target: '_blank', // 是否新开窗口
  path: '', // 图片地址
  picture_type: undefined, // app平台
  vice_img: [], // 副图
  demo_picture: '', // 示例
  literal_explan: '', // 示例说明
  hide_button: undefined, // 是否隐藏banner图按钮
  sprite_setting: {
    width: undefined,
    height: undefined,
    size: undefined,
    speed: undefined,
    direction: undefined,
  }
}

export const rules = {
  line_id: [{ required: true, message: '请选择发布平台', trigger: 'change' }],
  platform_class: [{ required: true, message: '请选择平台分类', trigger: 'change' }],
  picture_type: [{ required: true, message: '请选择APP类型', trigger: 'change' }],
  slug: [{ required: true, message: '请输入标识', trigger: 'change' }],
  class: [{ required: true, message: '请选择类型', trigger: 'change' }],
  link_url: [{ min: 0, max: 200, message: '最多输入200个字符', trigger: 'blur' }],
  alt: [{ required: true, message: '请输入alt属性', trigger: 'change' }],
  sort: [{ required: true, message: '请输入排序', trigger: 'change' }],
  start_at: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
  path: [{ required: true, message: '请上传图片', trigger: 'change' }],
  end_at: [{ required: true, message: '请选择结束时间', trigger: 'change' }]
}

export const strategyCommand = {
  edit({ id }) {
    this.$router.push(`/picture/edit/${id}`)
  },
  delete({ id }) {
    const _this = this
    this.$confirm({
      content: '确定要删除吗？',
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      async onOk() {
        const res = await api.deletePicture({ id })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功~')
          _this.getList()
        }
      }
    })
  },
  sort(data) {
    this.sortVal = data.sort
    this.waitItem = data
    this.sortVisible = true
  },
  async sortSure() {
    const data = { id: this.waitItem.id, sort: this.sortVal }
    const res = await api.sortPicture(data)
    if (this.$validate(res)) {
      this.$message.success('修改成功~')
      this.getList()
      this.sortVisible = false
    }
  },
  forbid(data) {
    const _this = this
    this.$confirm({
      content: `确定要${data.state === 1 ? '禁用' : '启用'}吗？`,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      async onOk() {
        const res = await api.statusPicture({ id: data.id, state: data.state === 1 ? 2 : 1 })
        if (_this.$validate(res)) {
          _this.$message.success('操作成功~')
          _this.getList()
        }
      }
    })
  },
  editPicPath(data) {
    this.waitItem = data
    this.pathVal = data.path
    this.pathVisible = true
  },
  async editPicPathSure() {
    const data = { id: this.waitItem.id, path: this.pathVal }
    const res = await api.updatePathPicture(data)
    if (this.$validate(res)) {
      this.$message.success('修改成功~')
      this.getList()
      this.pathVisible = false
    }
  },
  addParams(data) {
    this.params = []
    if (data.params) {
      Object.keys(data.params).forEach(key => {
        this.params.push({ name: key, value: data.params[key] })
      })
    } else {
      this.params.push({ key: '', name: '' })
    }
    this.waitItem = data
    this.pathVal = data.path
    this.paramsVisible = true
  },
  async addParamsSure() {
    const data = {}
    this.params.forEach(item => {
      const { name, value } = item
      if (name) {
        data[name] = value
      }
    })
    const params = { id: this.waitItem.id, params: data }
    const res = await api.paramsPicture(params)
    if (this.$validate(res)) {
      this.$message.success('修改成功~')
      this.getList()
      this.paramsVisible = false
    }
  }
}
